import Icon from '@material-ui/icons/PhonelinkSetup';
//import Icon  from '@material-ui/icons/PlaylistAddCheck';
//import Icon  from '@material-ui/icons/DevicesOther'
import List from './EquipmentList'
import Create from './EquipmentCreate'
import Edit from './EquipmentEdit'
import View from './EquipmentShow'

export default {
    list: List,
    edit: Edit,
    create: Create,
    show: View,
    icon: Icon,
};
